var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: { table_title: _vm.table_title },
    scopedSlots: _vm._u([
      {
        key: "datetime",
        fn: function() {
          return [
            _c("QpeDatetime", {
              attrs: {
                props_date: _vm.date,
                props_time: _vm.time,
                name: _vm.default_value
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "description",
        fn: function() {
          return [
            _c("SignsCalculator", {
              attrs: { data: _vm.sign_data, setting: _vm.sign_setting }
            })
          ]
        },
        proxy: true
      },
      {
        key: "signs",
        fn: function() {
          return [_c("MonitorSigns", { attrs: { data: _vm.sign_data } })]
        },
        proxy: true
      },
      {
        key: "data_table",
        fn: function(slot_props) {
          return [
            _c("QpeDatatable", {
              attrs: {
                data: _vm.table_data,
                headers: _vm.header,
                name: _vm.default_value,
                error_text: _vm.error_text,
                props_date: _vm.date,
                props_time: _vm.time,
                search: slot_props.search,
                should_display_info_header_key_value:
                  _vm.should_display_info_header_key_value,
                generate_tooltop_display_info:
                  _vm.generate_tooltop_display_info_for_table,
                should_show_raw_html_header: _vm.should_show_raw_html_header,
                show_footer: true,
                show_download_pdf_btn: _vm.show_download_pdf_btn,
                props_items_per_page: 100,
                no_data_text: "目前無警示測站"
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "table_description",
                    fn: function() {
                      return [
                        _c(
                          "span",
                          [
                            _vm._v(
                              _vm._s(
                                _vm.custom_alert_text[2]
                                  ? _vm.custom_alert_text[2]
                                  : "二級"
                              ) + "警戒： "
                            ),
                            _c("v-icon", { staticClass: "signal--warning" }, [
                              _vm._v("icon-pentagon")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _vm._v(
                              _vm._s(
                                _vm.custom_alert_text[1]
                                  ? _vm.custom_alert_text[1]
                                  : "一級"
                              ) + "警戒： "
                            ),
                            _c("v-icon", { staticClass: "signal--action" }, [
                              _vm._v("icon-triangle")
                            ])
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }